var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPublic = function SvgPublic(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.951 7.961 8 11l1.005-1.995L13 8l1.182-4.727M15 17l1-2-2.948-1.981-1.943-.124L10 14l2 3h3ZM12.813 3.035a8.994 8.994 0 0 0-9.778 9.778c.372 4.279 3.872 7.779 8.151 8.151a8.993 8.993 0 0 0 9.778-9.778c-.372-4.278-3.872-7.778-8.151-8.151Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPublic);
export default ForwardRef;